import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const StreakFreezeCheckIcon = ({ classObject }) => {
    return React.createElement("img", { src: "/assets/images/icons/streak_freeze_check.svg", className: css(styles.icon, classObject) });
};
const styles = StyleSheet.create({
    icon: {
        width: 40,
        height: 44,
    },
});
